import { BASE_URL } from 'consts';

const getIdExchangeUrl = (id: string) => {
  return `${BASE_URL}/v1/listings/exchange-id/${id}`;
};

export default getIdExchangeUrl;
